import React, { useState } from 'react'
import useStyles from './editDetailsStyles'
import effects from 'app/effects/effects'

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'

export default (props) => {
  const { formFields, setFormFields } = props
  const styleClass = useStyles()
  const [localState, setLocalState] = useState({
    suggestions: [],
  })

  const onChangeInput = (e) => {
    effects.apis.findJob({ jobTitle: e.target.value }).then((suggestions) => {
      setLocalState({
        ...localState,
        suggestions,
      })
    })

    setFormFields({
      ...formFields,
      jobTitle: e.target.value,
    })
  }

  const handleSelectOption = (e, value) => {
    setFormFields({
      ...formFields,
      jobTitle: value,
    })
  }

  return (
    <div className={styleClass.jobSuggestionWrapper}>
      <Autocomplete
        freeSolo
        disableClearable
        options={localState.suggestions.map((option) => option.name)}
        onChange={handleSelectOption}
        inputValue={formFields.jobTitle}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            margin="normal"
            value={formFields.jobTitle}
            name={'jobTitle'}
            onChange={onChangeInput}
            variant="standard"
          />
        )}
      />
    </div>
  )
}
